import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotificationsOverviewContainerComponent } from './containers/notification-overview/notification-overview-container.component';

const routes: Routes = [
    {
        path: '',
        component: NotificationsOverviewContainerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NotificationsRoutingModule {}
